import { generateAudio } from '@/request';
import { defineStore } from 'pinia';
import { useVideoStore } from './videoStore';
import { useDictsStore } from './dictsStore';
import { useDesignerStore } from './designerStore';
import { useAuthStore } from './authStore';
import { useUserStore } from './userStore';
import { getAppUserAmountInfo } from '@/request/user';
// import { useClipStore } from './clipStore';
import { nextTick } from 'vue';
import router from '@/router/index';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;

export const useMainStore = defineStore('main', {
  state: () => ({
    userInfo: '',
    liveFromPath: '',
    audioCount: 0,
    teamInfo: {} as { id?: string },
    projectId: '',
    audioCb: false,
    videoStatus: '',
    name: '',
    userInfoUpdate: 0,
    amountInfo: {},
    userResourceInfo: {},
  }),
  getters: {
    // AB: (state) => state.a + state.b,
  },
  actions: {
    // incrementA() {
    //   // eslint-disable-next-line no-plusplus
    //   this.a++;
    // },
    // incrementB() {
    //   setTimeout(() => {
    //     // eslint-disable-next-line no-plusplus
    //     this.b++;
    //   }, 1000);
    // },
    useAuthStoreFn() {
      const authStore = useAuthStore();
      // authStore.getTeamBenefitCodesFn();
    },
    setUserInfo(val) {
      this.userInfo = val;
      if (val?.teamId) this.teamInfo['teamId'] = val.teamId;
      localStorage.setItem('userInfo', JSON.stringify(val));
      // 检查是否有过去因为没token而进入页面失败的页面
      this.handlePostLoginRedirect();
    },

    setLiveFromPath(val) {
      this.liveFromPath = val;
    },
    setTeamInfo(val) {
      this.teamInfo = val;
      // 重新获取权限权益
      nextTick(() => {
        this.useAuthStoreFn();
      });
    },
    setProjectId(val) {
      this.projectId = val;
    },

    generateAudio() {
      this.audioCount = this.audioCount + 1;
    },

    changeAudioCb(flag, videoStatus, name) {
      this.audioCb = flag;
      this.videoStatus = videoStatus;
      this.name = name;
    },

    updateUserInfo(val) {
      this.userInfoUpdate = val;
    },

    async handlePostLoginRedirect() {
      const preLoginPath = sessionStorage.getItem('preLoginPath');
      if (preLoginPath) {
        sessionStorage.removeItem('preLoginPath');
        await nextTick(); // 确保路由切换前所有状态更新已完成
        router.push(preLoginPath);
      }
    },
    async getAppUserAmountInfoFn() {
      // if (!this.userInfo) return;
      const userStore = useUserStore();
      if (!userStore.getUserInfo) return;
      try {
        const response = await getAppUserAmountInfo();
        const { code, data, msg } = response.data;
        if (code === 200) {
          this.amountInfo = data;
          return data; // 返回数据
        } else {
          throw new Error(msg || '获取失败');
        }
      } catch (error) {
        console.error('An error occurred while fetching user amount info:', error);
        throw error; // 抛出错误
      }
    },

    resetStore() {
      // console.log('resetStore', this.userResourceInfo);
      this.userInfo = '';
      this.liveFromPath = '';
      this.audioCount = 0;
      this.teamInfo = {};
      this.projectId = '';
      this.audioCb = false;
      this.videoStatus = '';
      this.name = '';
      this.userInfoUpdate = 0;
      this.amountInfo = {};
    },
  },
});

export { useVideoStore, useDictsStore, useDesignerStore, useAuthStore, useUserStore };
